import { Box } from "@mui/material";

interface Props {
  icon: any;
  color?: string;
  /**
   * Lado do quadrado que envolve o ícone, em px. Padrão 40, que é a altura das
   * linhas de categoria e dos itens de lista.
   *
   * Existe para o ícone caber numa LINHA DE TEXTO — dentro do valor selecionado
   * de um `Select`, por exemplo, onde 40px empurram o campo para 56px de altura
   * e o deixam mais alto que os campos vizinhos.
   */
  size?: number;
}

export function BudgetItemIcon(props: Props) {
  const { color, size = 40 } = props;

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      width={size}
      minWidth={size}
      height={size}
      borderRadius={"6px"}
      sx={{
        "& svg, & svg path": {
          fill: color,
        },
      }}
    >
      {props.icon}
    </Box>
  );
}
